import { cn } from "@omni/utils/styles";
import { InputHTMLAttributes } from "react";

export type SwitchProps = {
    name: InputHTMLAttributes<HTMLInputElement>["name"];
    value: boolean;
    onToggle: () => void;
    label?: string;
    disabled?: boolean;
    className?: string;
};

const Switch = ({
    name,
    value,
    onToggle,
    label,
    disabled,
    className
}: SwitchProps) => {
    return (
        <div
            className={cn(
                "tw:inline-flex tw:items-center tw:h-4",
                {
                    "tw:cursor-pointer": !disabled
                },
                className
            )}
        >
            <input
                type="checkbox"
                className={cn("tw:sr-only tw:peer")}
                id={name}
                checked={!!value}
                onChange={onToggle}
                disabled={disabled}
            />
            <div
                onClick={onToggle}
                className={cn(
                    "tw:relative tw:w-7 tw:h-4 tw:bg-background tw:border tw:border-grey-input tw:peer-focus:border-primary",
                    "tw:peer-focus:outline-none tw:peer-focus:ring-4 tw:peer-focus:ring-input-focus",
                    "tw:rounded-full peer",
                    "tw:peer-checked:after:translate-x-full tw:peer-checked:after:border-white tw:after:content-['']",
                    "tw:peer-checked:after:bg-white tw:after:absolute tw:after:start-px tw:after:bg-grey-input",
                    "tw:after:border-grey-input tw:after:border tw:after:rounded-full",
                    "tw:after:h-3 tw:after:w-3 tw:after:top-px tw:after:transition-all",
                    "tw:peer-checked:bg-primary tw:peer-checked:border-primary"
                )}
            ></div>
            <label
                className={cn("tw:inline-block tw:m-0! tw:ml-2!")}
                htmlFor={name}
            >
                {label || ""}
            </label>
        </div>
    );
};

export { Switch };
